import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_LANGUAGE } from '../../../i18n/constants';
import { getUserLanguage } from '../../../i18n/helpers';
import type { Category } from '../../../stores/categories/CategoriesStore';
import { useStores } from '../../../stores/useStores';

import { NumberedGameItem } from './NumberedGameItem';
import styles from './NumberedGamesCarousel.module.scss';

export const NumberedGamesCarousel = observer(function NumberedGamesCarousel({
  id,
}: {
  id: Category['masterGameSubCategoryId'];
}) {
  const { i18n } = useTranslation();
  const language = getUserLanguage(i18n.language);
  const { categoriesStore } = useStores();
  const category = categoriesStore.categoriesRegistry[id];

  if (!category) return null;

  const rowName = category.name[language] || category.name[DEFAULT_LANGUAGE];

  return (
    <div className={styles.carousel}>
      {category.subCategoryGames.map((game, idx) => (
        <NumberedGameItem key={game.masterCasinoGameId} game={game} rank={idx} rowName={rowName} />
      ))}
    </div>
  );
});
